import createLoadingSelector from './create-loading-selector';

export default createLoadingSelector;
